var path = 'api/Portal/Certificate/'

const CertificateStatusEnum = {
    New: 1,
    SubmittedToVss: 2,
    MoreInformationRequested: 3,
    Decline: 4,
    Accepted: 5,
    Complete: 6,
    Void: 1003,
    DeclineRefund: 1002
}

function sendBirthCertOrder (http, dto) {
    return http.post(path + 'BirthOrder', dto)
}

function getIncompleteBirthOrders (http) {
    return http.get(path + 'GetIncompleteBirthOrders')
}

function getNewBirthOrders (http) {
    return http.get(path + 'GetNewBirthOrders')
}

function getBirthOrderById (http, id) {
    return http.get(path + 'GetBirthById?orderId=' + id)
}

function sendDeathCertOrder (http, dto) {
    return http.post(path + 'DeathOrder', dto)
}

function getIncompleteDeathOrders (http) {
    return http.get(path + 'GetIncompleteDeathOrders')
}

function getNewDeathOrders (http) {
    return http.get(path + 'GetNewDeathOrders')
}

function getDeathOrderById (http, id) {
    return http.get(path + 'GetDeathById?orderId=' + id)
}

function sendMarriageDivorceCertOrder (http, dto) {
    return http.post(path + 'MarriageDivorceOrder', dto)
}

function getIncompleteMarriageDivorceOrders (http) {
    return http.get(path + 'GetIncompleteMarriageDivorceOrders')
}

function getNewMarriageOrders (http) {
    return http.get(path + 'GetNewMarriageOrders')
}

function getNewDivorceOrders (http) {
    return http.get(path + 'GetNewDivorceOrders')
}

function getMarriageDivorceOrderById (http, id, modType) {
    return http.get(path + 'GetMarriageDivorceById?orderId=' + id + '&modType=' + modType)
}

function saveFiles (http, images) {
    return http.post(path + 'SaveFiles', images)
}

function getImagesByCertificate (http, type, id) {
    var search = { modType: type, certId: id }
    return http.post(path + 'GetImagesByCert?certId=' + id + '&modType=' + type, search)
}

function getImage (http, id) {
    return http.post(path + 'GetImage?imageId=' + id, { imageId: id }, { responseType: 'arraybuffer' })
}

function deleteImage (http, id) {
    return http.post(path + 'DeleteImage?imageId=' + id)
}

function getCostTable (http, modType, certType) {
    return http.post(path + 'GetCostTable?modType=' + modType + '&certType=' + certType)
}

function getCost (http, modType, numCerts, certType) {
    return http.post(path + 'GetCost?modType=' + modType + '&numCerts=' + numCerts + '&certType=' + certType)
}

function updateStatus (http, certId, modType) {
    return http.post(path + 'UpdateStatus?certId=' + certId + '&modType=' + modType)
}

function getOrderStatus (http, orderId, modType) {
    return http.get(path + 'GetOrderStatus?modType=' + modType + '&orderId=' + orderId)
}

function voidOrder (http, certId, modType) {
    return http.post(path + 'VoidOrder?certId=' + certId + '&modType=' + modType)
}

export default {
    CertificateStatusEnum: CertificateStatusEnum,
    sendBirthCertOrder: sendBirthCertOrder,
    getIncompleteBirthOrders: getIncompleteBirthOrders,
    getBirthOrderById: getBirthOrderById,
    sendDeathCertOrder: sendDeathCertOrder,
    getIncompleteDeathOrders: getIncompleteDeathOrders,
    getDeathOrderById: getDeathOrderById,
    saveFiles: saveFiles,
    getImagesByCertificate: getImagesByCertificate,
    sendMarriageDivorceCertOrder: sendMarriageDivorceCertOrder,
    getMarriageDivorceOrderById: getMarriageDivorceOrderById,
    getIncompleteMarriageDivorceOrders: getIncompleteMarriageDivorceOrders,
    getImage: getImage,
    deleteImage: deleteImage,
    getCostTable: getCostTable,
    getCost: getCost,
    getNewBirthOrders: getNewBirthOrders,
    getNewDeathOrders: getNewDeathOrders,
    getNewDivorceOrders: getNewDivorceOrders,
    getNewMarriageOrders: getNewMarriageOrders,
    updateStatus: updateStatus,
    getOrderStatus: getOrderStatus,
    voidOrder: voidOrder
}
